import { render } from "./StatisticsCategory.vue?vue&type=template&id=128bea60&scoped=true"
import script from "./StatisticsCategory.vue?vue&type=script&lang=js"
export * from "./StatisticsCategory.vue?vue&type=script&lang=js"

import "./StatisticsCategory.vue?vue&type=style&index=0&id=128bea60&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128bea60"]])

export default __exports__